import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import { Input, Button } from 'reactstrap';
import NepalMap from '../../components/NepalMap';
import ReactTable from "react-table";
import './style.css';
import { changeIndexToNepali } from '../../utils';
import classnames from 'classnames';
import Api from '../../services/api';
import MainLoader from '../../components/MainLoader';
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      provinceData: [],
      data: [],
      columns: null,
      palikaStatus: [],
      isLoading: true,
      searchInput: '',
      provinceColumns: null,
      currentFiscalYear: 0,
    };
  }

  async componentDidMount() {
    const { history } = this.props;
    await this.setState({
      currentFiscalYear: localStorage.getItem('fiscalYear')
    });
    let data = await Api.getPalikaDetailStiti({ fiscal_year_id: this.state.currentFiscalYear });
    let provinceData = data.response.provinces;
    data = data.response.lg;
    let columns = [{
      Header: 'क्र.सं.',
      maxWidth: 50,
      id: 'id',
      Cell: (row) => {
        return changeIndexToNepali(row.index + 1);
      }
    }, {
      Header: 'मन्त्रालय',
      id: 'name',
      accessor: d => {
        return (
          <span onClick={() => history.push(`/details/local/${d.gnid}`)} className="lg-name">{d.name}</span>
        );
      },
    }, {
      Header: 'जिल्ला',
      id: 'district',
      accessor: d => {
        return (
          <span className="lg-name">{d.district}</span>
        );
      },
    }, {
      Header: 'प्रदेश',
      id: 'province ',
      accessor: d => {
        return (
          <span className="lg-name">{d.province}</span>
        );
      },
    }, {
      Header: 'स्थिति',
      id: 'status',
      accessor: d => {
        return (
          <span className="lg-name">{d.status}</span>
        );
      },
    }, {
      Header: 'स्थिति मिति',
      id: 'status_date',
      accessor: d => {
        return (
          <span className="lg-name">{d.status_date}</span>
        );
      },
    }
    ];

    let provinceColumns = [{
      Header: 'क्र.सं.',
      maxWidth: 50,
      id: 'id',
      Cell: (row) => {
        return changeIndexToNepali(row.index + 1);
      }
    }, {
      Header: 'जम्मा स्थानीय तह',
      id: 'total_palikas',
      accessor: d => {
        return (
          <span className="lg-name">{changeIndexToNepali(d.total_palikas)}</span>
        );
      },
    }, {
      Header: 'प्रारम्भिक नतिजा तयार हुदैँ',
      id: 'status_draft_date ',
      accessor: d => {
        return (
          <span className="lg-name">{changeIndexToNepali(d.status_draft_date)}</span>
        );
      },
    }, {
      Header: 'प्रारम्भिक नतिजा पेश',
      id: 'status_in_review_date',
      accessor: d => {
        return (
          <span className="lg-name">{changeIndexToNepali(d.status_in_review_date)}</span>
        );
      },
    }, {
      Header: 'अनुमोदनका लागी पेश',
      id: 'status_reviewed_date',
      accessor: d => {
        return (
          <span className="lg-name">{changeIndexToNepali(d.status_reviewed_date)}</span>
        );
      },
    }, {
      Header: 'अन्तिम नतिजा कार्यपालिकाबाट अनुमोदन भइ सार्वजनिक',
      id: 'status_approved_date',
      accessor: d => {
        return (
          <span className="lg-name">{changeIndexToNepali(d.status_approved_date)}</span>
        );
      },
    }, {
      Header: 'बाँकी प्रगति',
      id: 'remaining',
      accessor: d => {
        return (
          <span className="lg-name">{changeIndexToNepali(d.remaining)}</span>
        );
      },
    }
    ];

    this.setState(
      {
        data: data,
        provinceData,
        columns: columns,
        isLoading: false,
        provinceColumns
      }
    )
  }

  _import2Excel = () => {
    const { data, columns } = this.state;
    let filteredData = this._getFilteredData();
    let excelColumns = [
      <ExcelColumn key="name" label="मन्त्रालय" value="name" />,
      <ExcelColumn key="ocmcm" label="मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालय" value="ocmcm" />,
      <ExcelColumn key="province" label="प्रदेश" value="province" />,
      <ExcelColumn key="status" label="स्थिति" value="status" />,
      <ExcelColumn key="status_date" label="स्थिति मिति" value="status_date" />,
    ];
    return (
      <ExcelFile element={<Button color="primary" style={{ marginRight: 10 }}>डाउनलोड</Button>}>
        <ExcelSheet data={filteredData} name="मन्त्रालय  स्थिति टेबल">
          {excelColumns}
        </ExcelSheet>
      </ExcelFile>
    );
  }

  _getFilteredData = () => {
    const { data, searchInput } = this.state;
    const searchKeys = ['name', 'province', 'ocmcm', 'status'];
    if (searchInput) {
      let filteredData = data.filter(d => {
        let found = false;
        searchKeys.map(searchKey => {
          if (d[searchKey].toString().includes(searchInput)) found = true;
        });
        return found;
      });
      return filteredData;
    }
    return data;
  }

  _onSearchInputChange = (e) => {
    this.setState({ searchInput: e.target.value });
  }

  renderProvinceStatus = () => {
    const { provinceData, provinceColumns } = this.state;
    return (
      <div className="province-status-wrapper">
        <h3 className="sub-heading">प्रदेश स्थिति टेबल</h3>
        {provinceData.length > 0 &&
          <ReactTable
            data={provinceData}
            columns={provinceColumns}
            defaultPageSize={7}
            showPagination={false}
            className="-striped -highlight"
          />
        }
      </div>
    );
  }

  render() {
    const { data, columns, isLoading } = this.state;
    return (
      <MainLoader active={isLoading}>
        <div className="">
          <div className="content">
            {this.renderProvinceStatus()}
            <div className="lg-status-wrapper">
              <h3 className="sub-heading">मन्त्रालय तह स्थिति टेबल</h3>
              {data.length > 0 &&
                <>
                  <div className="control-wrapper">
                    <Input className="search-input" type="text" name="search" placeholder="खोजी" value={this.state.searchInput || ""} onChange={this._onSearchInputChange} />
                    {this._import2Excel()}
                  </div>
                  <ReactTable
                    data={this._getFilteredData()}
                    columns={columns}
                    defaultPageSize={50}
                    className="-striped -highlight"
                  />
                </>
              }
            </div>
          </div>
        </div>
      </MainLoader>
    );
  }
}

const enhance = compose(withRouter);

export default enhance(Report);
